import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-large",
  "use": "user-large-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"user-large\"><title>user-large</title><g id=\"user-large_Layer_8\" data-name=\"Layer 8\"><path d=\"M20,19c-3.9287,0-7.125-3.5889-7.125-8S16.0713,3,20,3s7.125,3.5889,7.125,8S23.9287,19,20,19ZM20,5c-2.8262,0-5.125,2.6914-5.125,6S17.1738,17,20,17s5.125-2.6914,5.125-6S22.8262,5,20,5Z\" /><path d=\"M34,37H32V35.043a12,12,0,1,0-24,0V37H6V35.043a14,14,0,1,1,28,0Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user-large.svg
// module id = /JrC
// module chunks = 4